// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivityDetail_container__3_UGO","title":"ActivityDetail_title__2W7Vz","label__wrapper":"ActivityDetail_label__wrapper__1fcl6","label":"ActivityDetail_label__l6qtT"};